<footer class="footer">
    <div class="container">
    <div class="content has-text-centered">
      <p>
        
      </p>
    </div>
    </div>
    </footer>